
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stepup-for-students",
      function () {
        return require("private-next-pages/stepup-for-students.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stepup-for-students"])
      });
    }
  